module.exports = __webpack_public_path__ + "img/ky.af31884e.svg";